var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "categoryChildren" },
    [
      _c("div", { staticClass: "categoryChildren-cnt" }, [
        _c("div", { staticClass: "categoryChildren-cnt-left" }, [
          _c(
            "div",
            {
              staticClass: "btn",
              staticStyle: { padding: "0px 20px", "box-sizing": "border-box" },
            },
            [
              _c("el-input", {
                attrs: {
                  placeholder: "品类搜索",
                  "prefix-icon": "el-icon-search",
                },
                on: { change: _vm.changeTwoCate },
                model: {
                  value: _vm.cateName,
                  callback: function ($$v) {
                    _vm.cateName = $$v
                  },
                  expression: "cateName",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "overlist" },
            _vm._l(_vm.showList, function (item) {
              return _c(
                "div",
                {
                  key: item.id,
                  staticStyle: { width: "100%", "margin-bottom": "5px" },
                },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { width: "100%", "margin-right": "10px" },
                      attrs: {
                        type: _vm.firstlistindex == item.id ? "primary" : "",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.firstlistclick(item)
                        },
                      },
                    },
                    [_vm._v(_vm._s(item.name))]
                  ),
                  _c(
                    "el-dropdown",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.firstlistindex == item.id,
                          expression: "firstlistindex == item.id",
                        },
                      ],
                      attrs: { placement: "bottom-start" },
                      on: { command: (event) => _vm.handleClick(event, item) },
                    },
                    [
                      _c("span", { staticClass: "el-dropdown-link" }, [
                        _vm._v(" ⋮ "),
                      ]),
                      _c(
                        "el-dropdown-menu",
                        { attrs: { slot: "dropdown" }, slot: "dropdown" },
                        [
                          _c("el-dropdown-item", { attrs: { command: "a" } }, [
                            _vm._v("查看品类"),
                          ]),
                          _c("el-dropdown-item", { attrs: { command: "b" } }, [
                            _vm._v("编辑品类"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            0
          ),
          _c(
            "div",
            { staticClass: "btn" },
            [
              _c(
                "el-button",
                {
                  staticStyle: { width: "82%" },
                  attrs: { type: "primary" },
                  on: { click: _vm.addChild },
                },
                [_vm._v("新增二级品类")]
              ),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "categoryChildren-cnt-right" }, [
          _c(
            "div",
            { staticStyle: { "margin-bottom": "10px" } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.onHandleTag()
                    },
                  },
                },
                [_vm._v("新增三级品类")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handlePublishingRule },
                },
                [_vm._v("发布规则配置")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleGoodsName },
                },
                [_vm._v("商品命名规则")]
              ),
              _vm.logistic_business_ids.includes(2)
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.allclick(2)
                        },
                      },
                    },
                    [_vm._v("高碑店排序/显隐")]
                  )
                : _vm._e(),
              _vm.logistic_business_ids.includes(549)
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.allclick(549)
                        },
                      },
                    },
                    [_vm._v("孝感排序/显隐")]
                  )
                : _vm._e(),
              _vm.firstName
                ? _c("span", { staticClass: "firstNameWrap" }, [
                    _vm._v("所属一级品类【" + _vm._s(_vm.firstName) + "】"),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "auto-table-flex" },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  attrs: {
                    data: _vm.tableData,
                    height: "100%",
                    border: true,
                    "header-cell-style": {
                      color: "#333333",
                      background: "#EFF6FF",
                    },
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      type: "index",
                      width: "100px",
                      align: "center",
                      label: "序号",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "name",
                      align: "center",
                      label: "三级品类名称",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "name",
                      align: "center",
                      label: "商品命名规则",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [_vm._v(" " + _vm._s(_vm.tabname) + " ")]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "name", align: "center", label: "操作" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.onHandleCreateall(scope.row)
                                  },
                                },
                              },
                              [_vm._v("商品导入")]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm.childDialogVisible
        ? _c(
            "el-dialog",
            {
              ref: "refChildCategoryDialog",
              staticClass: "dialog",
              attrs: {
                title: _vm.childTitle,
                visible: _vm.childDialogVisible,
                width: "85%",
                center: "",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.childDialogVisible = $event
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "contents" },
                [
                  _c(
                    "el-form",
                    {
                      ref: "childForm",
                      staticClass: "demo-ruleForm",
                      attrs: {
                        model: _vm.childForm,
                        rules: _vm.childRules,
                        "label-width": "200px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "父级品类", prop: "pid" } },
                        [
                          _c(
                            "div",
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    clearable: "",
                                    disabled: _vm.childDisabled,
                                    placeholder: "选择父级品类",
                                  },
                                  model: {
                                    value: _vm.childForm.pid,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.childForm, "pid", $$v)
                                    },
                                    expression: "childForm.pid",
                                  },
                                },
                                _vm._l(_vm.options, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: { label: item.name, value: item.id },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "品类名称", prop: "name" } },
                        [
                          _c(
                            "div",
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入品类名称",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.childForm.name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.childForm, "name", $$v)
                                  },
                                  expression: "childForm.name",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "运费系数(%)",
                            prop: "freight_parameter",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "inputs" },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入运费",
                                  clearable: "",
                                },
                                on: { blur: _vm.freightBlur },
                                model: {
                                  value: _vm.childForm.freight_parameter,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.childForm,
                                      "freight_parameter",
                                      $$v
                                    )
                                  },
                                  expression: "childForm.freight_parameter",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "服务费系数(%)",
                            prop: "purchase_parameter",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "inputs" },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入服务费",
                                  clearable: "",
                                },
                                on: { blur: _vm.purchaseBlur },
                                model: {
                                  value: _vm.childForm.purchase_parameter,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.childForm,
                                      "purchase_parameter",
                                      $$v
                                    )
                                  },
                                  expression: "childForm.purchase_parameter",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "毛重/净重差" } },
                        [
                          _vm._l(
                            _vm.weight_difference_rules,
                            function (tItem, tIndex) {
                              return _c("div", { key: tIndex }, [
                                _c(
                                  "div",
                                  { staticClass: "d-flex a-center mb-10" },
                                  [
                                    _c(
                                      "div",
                                      { staticStyle: { width: "300px" } },
                                      [
                                        _c(
                                          "el-select",
                                          {
                                            attrs: {
                                              clearable: "",
                                              placeholder: "请选择",
                                            },
                                            on: {
                                              change: (e) =>
                                                _vm.changeType(e, tIndex),
                                            },
                                            model: {
                                              value: tItem.type,
                                              callback: function ($$v) {
                                                _vm.$set(tItem, "type", $$v)
                                              },
                                              expression: "tItem.type",
                                            },
                                          },
                                          _vm._l(
                                            _vm.diffTypeList,
                                            function (item) {
                                              return _c("el-option", {
                                                key: item.id,
                                                attrs: {
                                                  label: item.name,
                                                  value: item.id,
                                                  disabled: _vm.isTypeSelected(
                                                    item.id,
                                                    tIndex
                                                  ),
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    tIndex < 1
                                      ? _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "margin-left": "10px",
                                              cursor: "pointer",
                                            },
                                            on: { click: _vm.addOption },
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "el-icon-circle-plus-outline",
                                              staticStyle: { color: "#13ae67" },
                                              attrs: { size: "16" },
                                            }),
                                          ]
                                        )
                                      : _vm._e(),
                                    tIndex != 0
                                      ? _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "margin-left": "10px",
                                              cursor: "pointer",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.deleteOption(tItem)
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass:
                                                "el-icon-remove-outline",
                                              staticStyle: { color: "#13ae67" },
                                            }),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                                tItem.type == 1
                                  ? _c(
                                      "div",
                                      _vm._l(
                                        tItem.rule,
                                        function (ctItem, ctIndex) {
                                          return _c(
                                            "div",
                                            {
                                              key: ctIndex,
                                              staticClass:
                                                "d-flex a-center mb-10",
                                            },
                                            [
                                              ctIndex != 0
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        "margin-right": "5px",
                                                        cursor: "pointer",
                                                        width: "15px",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.deleteOptionChild(
                                                            tIndex,
                                                            ctItem
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-remove-outline",
                                                        staticStyle: {
                                                          color: "#13ae67",
                                                        },
                                                      }),
                                                    ]
                                                  )
                                                : _c("div", {
                                                    staticStyle: {
                                                      "margin-right": "5px",
                                                      width: "15px",
                                                    },
                                                  }),
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    "margin-right": "5px",
                                                    cursor: "pointer",
                                                    width: "15px",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.addOptionChild(
                                                        tIndex
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-circle-plus-outline",
                                                    staticStyle: {
                                                      color: "#13ae67",
                                                    },
                                                    attrs: { size: "16" },
                                                  }),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "mr10" },
                                                [_vm._v("毛重")]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "mr10",
                                                  staticStyle: {
                                                    width: "100px",
                                                  },
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      placeholder: "请输入",
                                                      clearable: "",
                                                    },
                                                    on: {
                                                      blur: () =>
                                                        (ctItem.min =
                                                          ctItem.min == 0
                                                            ? 0
                                                            : _vm.tool.filterUnNumber(
                                                                ctItem.min,
                                                                true
                                                              )),
                                                    },
                                                    model: {
                                                      value: ctItem.min,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          ctItem,
                                                          "min",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "ctItem.min",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "ml10 mr10" },
                                                [_vm._v("--")]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "mr10",
                                                  staticStyle: {
                                                    width: "100px",
                                                  },
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      placeholder: "请输入",
                                                      clearable: "",
                                                    },
                                                    on: {
                                                      blur: () =>
                                                        (ctItem.max =
                                                          _vm.tool.filterUnNumber(
                                                            ctItem.max,
                                                            true
                                                          )),
                                                    },
                                                    model: {
                                                      value: ctItem.max,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          ctItem,
                                                          "max",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "ctItem.max",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "mr10",
                                                  staticStyle: {
                                                    width: "100px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-select",
                                                    {
                                                      attrs: {
                                                        clearable: "",
                                                        placeholder: "请选择",
                                                      },
                                                      model: {
                                                        value: ctItem.max_type,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            ctItem,
                                                            "max_type",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "ctItem.max_type",
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.unitTypeList,
                                                      function (item) {
                                                        return _c("el-option", {
                                                          key: item.id,
                                                          attrs: {
                                                            label: item.name,
                                                            value: item.id,
                                                          },
                                                        })
                                                      }
                                                    ),
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "mr10" },
                                                [_vm._v("商品正负差异")]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "mr10",
                                                  staticStyle: {
                                                    width: "100px",
                                                  },
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      placeholder: "请输入",
                                                      clearable: "",
                                                    },
                                                    on: {
                                                      blur: () =>
                                                        (ctItem.diff_jin =
                                                          _vm.tool.limitDecimalInput(
                                                            ctItem.diff_jin
                                                          )),
                                                    },
                                                    model: {
                                                      value: ctItem.diff_jin,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          ctItem,
                                                          "diff_jin",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "ctItem.diff_jin",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c("div", [_vm._v("斤")]),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  : _vm._e(),
                                tItem.type == 2
                                  ? _c(
                                      "div",
                                      _vm._l(
                                        tItem.rule,
                                        function (ctItem, ctIndex) {
                                          return _c(
                                            "div",
                                            {
                                              key: ctIndex,
                                              staticClass:
                                                "d-flex a-center mb-10",
                                            },
                                            [
                                              ctIndex != 0
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        "margin-right": "10px",
                                                        cursor: "pointer",
                                                        width: "15px",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.deleteOptionChild(
                                                            tIndex,
                                                            ctItem
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-remove-outline",
                                                        staticStyle: {
                                                          color: "#13ae67",
                                                        },
                                                      }),
                                                    ]
                                                  )
                                                : _c("div", {
                                                    staticStyle: {
                                                      "margin-right": "10px",
                                                      width: "15px",
                                                    },
                                                  }),
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    "margin-right": "10px",
                                                    cursor: "pointer",
                                                    width: "15px",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.addOptionChild(
                                                        tIndex
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-circle-plus-outline",
                                                    staticStyle: {
                                                      color: "#13ae67",
                                                    },
                                                    attrs: { size: "16" },
                                                  }),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "mr10" },
                                                [_vm._v("礼盒装")]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "mr10",
                                                  staticStyle: {
                                                    width: "100px",
                                                  },
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      placeholder: "请输入",
                                                      clearable: "",
                                                    },
                                                    on: {
                                                      blur: () =>
                                                        (ctItem.min =
                                                          ctItem.min == 0
                                                            ? 0
                                                            : _vm.tool.filterUnNumber(
                                                                ctItem.min,
                                                                true
                                                              )),
                                                    },
                                                    model: {
                                                      value: ctItem.min,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          ctItem,
                                                          "min",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "ctItem.min",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "ml10 mr10" },
                                                [_vm._v("--")]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "mr10",
                                                  staticStyle: {
                                                    width: "100px",
                                                  },
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      placeholder: "请输入",
                                                      clearable: "",
                                                    },
                                                    on: {
                                                      blur: () =>
                                                        (ctItem.max =
                                                          _vm.tool.filterUnNumber(
                                                            ctItem.max,
                                                            true
                                                          )),
                                                    },
                                                    model: {
                                                      value: ctItem.max,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          ctItem,
                                                          "max",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "ctItem.max",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "mr10",
                                                  staticStyle: {
                                                    width: "100px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-select",
                                                    {
                                                      attrs: {
                                                        clearable: "",
                                                        placeholder: "请选择",
                                                      },
                                                      model: {
                                                        value: ctItem.max_type,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            ctItem,
                                                            "max_type",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "ctItem.max_type",
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.unitTypeList,
                                                      function (item) {
                                                        return _c("el-option", {
                                                          key: item.id,
                                                          attrs: {
                                                            label: item.name,
                                                            value: item.id,
                                                          },
                                                        })
                                                      }
                                                    ),
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "mr10" },
                                                [_vm._v("商品正负差异")]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "mr10",
                                                  staticStyle: {
                                                    width: "100px",
                                                  },
                                                },
                                                [
                                                  _c("el-input", {
                                                    attrs: {
                                                      placeholder: "请输入",
                                                      clearable: "",
                                                    },
                                                    on: {
                                                      blur: () =>
                                                        (ctItem.diff_jin =
                                                          _vm.tool.limitDecimalInput(
                                                            ctItem.diff_jin
                                                          )),
                                                    },
                                                    model: {
                                                      value: ctItem.diff_jin,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          ctItem,
                                                          "diff_jin",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "ctItem.diff_jin",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _c("div", [
                                                _vm._v(
                                                  " 斤,按照毛重进行报损或者品控，并且客户报损时如净重缺称 则直接进行赔付。 "
                                                ),
                                              ]),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  : _vm._e(),
                              ])
                            }
                          ),
                          _c("div"),
                        ],
                        2
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "排序", prop: "listorder" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入排序值",
                              maxlength: "5",
                              clearable: "",
                            },
                            model: {
                              value: _vm.childForm.listorder,
                              callback: function ($$v) {
                                _vm.$set(_vm.childForm, "listorder", $$v)
                              },
                              expression: "childForm.listorder",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "商品详情默认图片",
                            prop: "detail_pic",
                          },
                        },
                        [
                          _c("b-file-upload", {
                            key: "detail_pic",
                            attrs: {
                              accepts: ["jpg", "jpeg", "png"],
                              limit: 1,
                            },
                            model: {
                              value: _vm.detailPicList,
                              callback: function ($$v) {
                                _vm.detailPicList = $$v
                              },
                              expression: "detailPicList",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "商品详情默认视频",
                            prop: "detail_video",
                          },
                        },
                        [
                          _c("b-file-upload", {
                            key: "detail_video",
                            attrs: {
                              accepts: ["mp4", "avi", "flv", "mov"],
                              limit: 1,
                            },
                            model: {
                              value: _vm.detailVideoList,
                              callback: function ($$v) {
                                _vm.detailVideoList = $$v
                              },
                              expression: "detailVideoList",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "禁售城市仓", prop: "logistic_id" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "logistic-select_wrap",
                              attrs: {
                                placeholder: "选择禁售城市仓",
                                loading: _vm.loadingCityStore,
                                multiple: "",
                                filterable: "",
                                clearable: "",
                              },
                              on: { change: _vm.onCityStore },
                              model: {
                                value: _vm.logisticIds,
                                callback: function ($$v) {
                                  _vm.logisticIds = $$v
                                },
                                expression: "logisticIds",
                              },
                            },
                            _vm._l(_vm.cityStoreList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.childForm.id && _vm.childForm.is_audit_gao == 1
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "选择招商", prop: "buyer_id" } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    clearable: "",
                                    placeholder: "选择选择招商",
                                  },
                                  model: {
                                    value: _vm.childForm.buyer_id,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.childForm, "buyer_id", $$v)
                                    },
                                    expression: "childForm.buyer_id",
                                  },
                                },
                                _vm._l(_vm.updatecategorylist, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: {
                                      label: item.fullname,
                                      value: item.id,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "高碑店集配发品是否需要审核",
                            prop: "is_audit_gao",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: {
                                disabled: _vm.is_audit_gao == 1 ? true : false,
                              },
                              on: { change: _vm.gaochang },
                              model: {
                                value: _vm.childForm.is_audit_gao,
                                callback: function ($$v) {
                                  _vm.$set(_vm.childForm, "is_audit_gao", $$v)
                                },
                                expression: "childForm.is_audit_gao",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("是"),
                              ]),
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("否"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "孝感集配发品是否需要审核",
                            prop: "is_audit_xiao",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: {
                                disabled: _vm.is_audit_xiao == 1 ? true : false,
                              },
                              model: {
                                value: _vm.childForm.is_audit_xiao,
                                callback: function ($$v) {
                                  _vm.$set(_vm.childForm, "is_audit_xiao", $$v)
                                },
                                expression: "childForm.is_audit_xiao",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("是"),
                              ]),
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("否"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.childTitle != "查看子类"
                ? _c(
                    "span",
                    {
                      staticClass: "dialog-footer",
                      attrs: { slot: "footer" },
                      slot: "footer",
                    },
                    [
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              _vm.childDialogVisible = false
                            },
                          },
                        },
                        [_vm._v("取 消")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.childConfirm },
                        },
                        [_vm._v("确认")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _c("goods-tag-dialog", {
        ref: "refGoodsTagDialog",
        on: { "on-change": _vm.ajaxGetCategories },
      }),
      _c(
        "el-drawer",
        {
          attrs: {
            title: "品类排序",
            visible: _vm.drawer,
            direction: "rtl",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "div",
                {
                  staticStyle: {
                    "text-align": "right",
                    "margin-bottom": "20px",
                  },
                },
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.submit } },
                    [_vm._v("保存")]
                  ),
                ],
                1
              ),
              _c(
                "el-table",
                {
                  ref: "draggableTable",
                  attrs: {
                    data: _vm.tableDatasorst,
                    "row-key": "id",
                    stripe: "",
                    height: "100%",
                    border: true,
                    "header-cell-style": {
                      color: "#333333",
                      background: "#EFF6FF",
                    },
                  },
                  on: { "row-dragged": _vm.handleRowDragged },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      type: "index",
                      width: "100",
                      align: "center",
                      label: "序号",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "is_show",
                      align: "center",
                      label: "是否显示隐藏",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm.source == 2
                              ? _c("el-switch", {
                                  attrs: {
                                    "active-value": 1,
                                    "active-color": "#13AE67",
                                    "inactive-value": 0,
                                    "inactive-color": "#C0CCDA",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.handleSwitchChange(
                                        scope.row,
                                        scope.$index
                                      )
                                    },
                                  },
                                  model: {
                                    value:
                                      _vm.tableDatasorst[scope.$index].is_show,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.tableDatasorst[scope.$index],
                                        "is_show",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "tableDatasorst[scope.$index].is_show",
                                  },
                                })
                              : _c("el-switch", {
                                  attrs: {
                                    "active-value": 1,
                                    "active-color": "#13AE67",
                                    "inactive-value": 0,
                                    "inactive-color": "#C0CCDA",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.handleSwitchChange(
                                        scope.row,
                                        scope.$index
                                      )
                                    },
                                  },
                                  model: {
                                    value:
                                      _vm.tableDatasorst[scope.$index]
                                        .is_show_xiao,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.tableDatasorst[scope.$index],
                                        "is_show_xiao",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "tableDatasorst[scope.$index].is_show_xiao",
                                  },
                                }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "name", label: "名称" },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "item.prop",
                      align: "center",
                      label: "操作",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [_c("i", { staticClass: "el-icon-rank" })]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c("productNameRule", {
        ref: "productNameRuleRef",
        on: { "on-change": _vm.ajaxGetCategories },
      }),
      _c("editdataalldialog", {
        ref: "refEditDataallDialog",
        on: { dialogVisibleChange: _vm.ajaxGetCategories },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }